var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.profile.tabs.personal_data.personal"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      modalLarge: true,
      "loading-primary-footer-button": _vm.isLoading,
      showSecondaryFooterButton: false,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "profile" }, [
              _c("article", [
                _vm.error
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-danger",
                        attrs: { role: "alert" },
                      },
                      [_vm._v(" " + _vm._s(_vm.error) + " ")]
                    )
                  : _vm._e(),
                _c("form", [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _vm.canEditCass
                          ? _c("employee-social-security-field", {
                              attrs: {
                                id: "edit-employee-social-security",
                                name: "socialSecurityNo",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                        _vm.canEditResidence
                          ? _c("employee-no-authorization-residente-field", {
                              attrs: {
                                id: "edit-employee-no-authorization-residente",
                                name: "noAutorizacionResidente",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                        _vm.canEditCassExpiration
                          ? _c("employee-cass-expiration-date-field", {
                              attrs: {
                                id: "edit-employee-cass-expiration-date",
                                name: "cassExpirationDate",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _vm.canEditPassport
                          ? _c("employee-dni-number-field", {
                              attrs: {
                                id: "edit-employee-dni-number",
                                name: "dniNumber",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                        _vm.canEditPassportExp
                          ? _c("employee-dni-expiration-date-field", {
                              attrs: {
                                id: "edit-employee-dni-expiration-date",
                                name: "dniExpirationDate",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                        _vm.canEditBornDate
                          ? _c("employee-birth-day-field", {
                              attrs: {
                                id: "edit-employee-birth-day",
                                name: "birthDate",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }